const expense = {
  path: 'expense',
  component: resolve => require(['@/pages/admin/recharge/expense'], resolve)
}

export default expense
